/* eslint-disable no-prototype-builtins */
// Custom function to merge objects to fix Dynamic Code Evaluation (e. g. 'eval', 'new Function', 'WebAssembly.compile') not allowed in Edge Runtime
// Learn More: https://nextjs.org/docs/messages/edge-dynamic-code-evaluation
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mergeObjects(target: any, ...sources: any[]): any {
    sources.forEach((source) => {
        for (const key in source) {
            if (source.hasOwnProperty(key)) {
                if (typeof source[key] === 'object' && source[key] !== null) {
                    if (!target[key]) {
                        target[key] = {};
                    }
                    mergeObjects(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            }
        }
    });
    return target;
}

export default mergeObjects;
